module.exports = __webpack_public_path__ + "img/mos-swiper-pad1.76979e53.png";